import { render, staticRenderFns } from "./LangSetting.vue?vue&type=template&id=330cd828&scoped=true"
import script from "./LangSetting.vue?vue&type=script&lang=js"
export * from "./LangSetting.vue?vue&type=script&lang=js"
import style0 from "./LangSetting.vue?vue&type=style&index=0&id=330cd828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330cd828",
  null
  
)

export default component.exports